export const dateRangeFilterMethod = ({ id, value }, row) => {
    if (value[0] && value[1]) {
        const rowDate = new Date(row[id]);
        rowDate.setHours(0, 0, 0, 0);

        const startDate = new Date(value[0]);
        startDate.setHours(0, 0, 0, 0);

        const endDate = new Date(value[1]);
        endDate.setHours(0, 0, 0, 0);

        return rowDate >= startDate && rowDate <= endDate;
    }
    return true;
};